import type { ServerAttachmentVM } from "./ServerAttachmentVM";

/// The VM for attachment in the client side, which is different from the one in the server side
export interface AttachmentViewModel {
  id: string;
  originalFileName: string;
  name: string;
}

export function attachmentViewModelToServerModel(
  avm: AttachmentViewModel
): ServerAttachmentVM {
  const r: ServerAttachmentVM = {
    attachmentId: avm.id,
    originalFileName: avm.originalFileName,
    attachmentName: avm.name,
  };

  return r;
}
